const hostname = window.location.hostname;
const windowWidth = window.innerWidth
// const windowHeight = window.outerHeight
const windowHeight = window.innerHeight
const mainWrapper = document.querySelector('.main')
const APPLY_FORM_HASH = '#apply-form'
const APPLY_FORM_TITLE_SELECTOR = '[data-apply-form-title]'
const APPLY_FORM_SECTION_SELECTOR = '[data-apply-form-section]'
const APPLY_FORM_MEDIA_SELECTOR = '[data-apply-form-media]'
let scroll,
    staggerDefault = 0.05,
    durationDefault = 0.6,
    disableBackgroundColor = false,
    pendingApplyFormHashScroll = Boolean(window.__applyFormHashRequested) || window.location.hash === APPLY_FORM_HASH,
    hasEarlyScrollIntent = false,
    isPreloaderHidden = false,
    applyFormNavigationRequestId = 0

function markEarlyScrollIntent() {
    hasEarlyScrollIntent = true
}

window.addEventListener('wheel', markEarlyScrollIntent, { passive: true })
window.addEventListener('touchstart', markEarlyScrollIntent, { passive: true })
window.addEventListener('touchmove', markEarlyScrollIntent, { passive: true })
window.addEventListener('scroll', () => {
    if ((window.scrollY || window.pageYOffset || 0) > 4) {
        markEarlyScrollIntent()
    }
}, { passive: true })

mainWrapper?.addEventListener('scroll', () => {
    if (mainWrapper.scrollTop > 4) {
        markEarlyScrollIntent()
    }
}, { passive: true })

window.addEventListener('keydown', event => {
    if ([' ', 'ArrowDown', 'ArrowUp', 'PageDown', 'PageUp', 'Home', 'End'].includes(event.key)) {
        markEarlyScrollIntent()
    }
})

CustomEase.create("nbs", "0.625, 0.05, 0, 1")
CustomEase.create('osmoBounce', 'M0,0 C0.18,0.9 0.32,1.1 0.44,1.12 C0.52,1.10 0.60,0.98 0.66,0.96 C0.72,0.95 0.80,1.03 0.85,1.04 C0.92,1.02 0.97,1.0 1,1')
CustomEase.create('bounce2','M0,0 C0.10,0 0.20,0 0.28,0 C0.36,1.7 0.40,1.7 0.42,1.45 C0.48,0.85 0.52,0.9 0.56,1 C0.62,1.35 0.66,1.35 0.68,1.12 C0.76,0.98 0.86,1 1,1')

gsap.defaults({ ease: "nbs", duration: durationDefault })

document.addEventListener('DOMContentLoaded', () => {
    resetScrollToTop()
    if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(() => {
            initScript()
        })
    } else {
        window.addEventListener('load', initScript)
    }
})

function initScript() {
    initCheckWindowHeight()
    initBasicFunctions()
    initSmoothScroll()
    runPageEnterAnimation()

    initAccordion()
    initLangSwitcher()
    waveSections()
    formContactPopup()
    menuMobile()
    scrollTriggerAnimations()
    initLazyVideos()
    initApplyFormHashNavigation()
}

function runPageEnterAnimation() {
    if (shouldSkipPageEnterLock()) {
        if (!pendingApplyFormHashScroll) {
            hidePreloader()
        }
        return
    }

    const homeTitle = new SplitText('[data-home-heading]', {
        type: "lines, words, chars",
        mask: windowWidth >= 1280 ? "lines" : "chars",
        linesClass: "text-line",
    })

    const tl = gsap.timeline()
    tl.to('.preloader > div', {delay:.1,y:-10,autoAlpha:0,scale:.9,stagger:.1}, '<')
    tl.fromTo('.preloader', {autoAlpha:1},{
        autoAlpha: 0,
        duration: 0.5,
        ease: "power1.inOut"
    }, '<+=.5')

    if(windowWidth >= 1280) {
        tl.set(homeTitle.chars, {
            x: 50,
            autoAlpha:0,
            filter: 'blur(5px)'
        }, '<-=.2')
    }else {
        tl.set(homeTitle.lines, {
            scale: .9,
            y: 50,
            autoAlpha:0,
        }, '<')
    }

    if(windowWidth >= 1280) {
        tl.to(homeTitle.chars, {
            x: 0,
            autoAlpha: 1,
            filter: 'blur(0px)',
            duration: 2,
            ease: "expo.out",
            stagger: 0.01,
        }, '<')
    }else {
        tl.to(homeTitle.lines, {
            scale: 1,
            y: 0,
            autoAlpha: 1,
            duration: 2,
            ease: "expo.out",
            stagger: 0.15,
        }, '<+=.25')
    }

    tl.from('.wrap_top_text', {
        autoAlpha:0,
        y:10,
        duration: 1.2,
        stagger:.1,
        ease: "expo.out"
    }, '<+=.5')

    tl.from('.big_seller', {
        autoAlpha:0,
        duration: 1.2,
        filter: windowWidth >= 1280 ? 'blur(10px)' : 'none',
        stagger:.1,
        ease: "expo.out"
    }, '<')

    tl.from('.header_top', {
        autoAlpha:0,
        duration: 1.2,
        filter: windowWidth >= 1280 ? 'blur(10px)' : 'none',
        stagger:.1,
        ease: "expo.out",
        onComplete() {
            isPreloaderHidden = true
        }
    }, '<')
}

function shouldSkipPageEnterLock() {
    return pendingApplyFormHashScroll || hasEarlyScrollIntent || getCurrentScrollPosition() > 4
}

function hidePreloader() {
    if (isPreloaderHidden) return

    isPreloaderHidden = true
    gsap.killTweensOf('.preloader')
    gsap.killTweensOf('.preloader > div')

    gsap.to('.preloader > div', {
        y: -10,
        autoAlpha: 0,
        scale: 0.9,
        stagger: 0.08,
        duration: 0.24,
        overwrite: true,
    })

    gsap.to('.preloader', {
        autoAlpha: 0,
        duration: 0.28,
        ease: 'power1.out',
        overwrite: true,
        onComplete() {
            gsap.set('.preloader', { display: 'none' })
        }
    })
}

function releaseApplyFormPendingState() {
    document.documentElement.classList.remove('apply-form-pending')
}

function initSmoothScroll() {
    const mobileMainScroller = window.innerWidth < 1280 ? document.querySelector('.main') : null

    scroll = new Lenis({
        lerp: .2,
        duration: .8,
        ...(mobileMainScroller ? {
            wrapper: mobileMainScroller,
            content: mobileMainScroller,
        } : {})
    })

    scroll.on('scroll', ScrollTrigger.update)

    gsap.ticker.add((time)=>{
        scroll.raf(time * 1000)
    })

    gsap.ticker.lagSmoothing(0)

    ScrollTrigger.refresh()
}

function initCheckWindowHeight() {
    let vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', `${vh}px`);
}

function initBasicFunctions() {
    const imgs = document.querySelectorAll('img[loading="lazy"]')
    imgs.forEach(img => {
        img.loading = 'eager'
        img.removeAttribute('loading')

        if (!img.complete) {
            const src = img.currentSrc || img.src
            if (src) {
                img.src = ''
                img.src = src
            }
        }

        img.decode?.().catch(() => {})
    })
}

function scrollTriggerAnimations() {
    if(windowWidth < 1280) {
        ScrollTrigger.defaults({ scroller: document.querySelector('.main') })
    }

    const topFirstSection = document.getElementById('top-first-section')
    if(topFirstSection) {
        if(windowWidth >= 1280) {
            gsap.set(topFirstSection, {height: windowHeight * 3})
            const stickySection = topFirstSection.querySelector('.top-sticky-section')
            const topFirstSectionRect = topFirstSection.getBoundingClientRect()
            const topStickySection = stickySection.getBoundingClientRect()

            gsap.set('.top-decor-1', {rotate:45,scale:.3,autoAlpha:0,transformOrigin:'center'})
            gsap.set('.top-decor-3', {rotate:-45,scale:.3,autoAlpha:0,transformOrigin:'center'})
            gsap.set('.top-decor-2', {scaleY:0,scaleX:.9,rotate:-2,transformOrigin:'center top'})

            const tlTopDecor = gsap.timeline({ paused: true })

            tlTopDecor
                .to('.top-decor-1', {
                    scale:1,
                    rotate:0,
                    autoAlpha:1,
                    duration: .3,
                    ease: 'none'
                }, '<')
                .to('.top-decor-3', {
                    scale:1,
                    rotate:0,
                    autoAlpha:1,
                    duration: .3,
                    ease: 'none'
                }, '<')
                .to('.top-decor-2', {
                    scaleY:1,
                    scaleX:1,
                    y:0,
                    rotate:0,
                    autoAlpha: 1,
                    duration: .3,
                    ease: 'none'
                }, '<+=.2')


            ScrollTrigger.create({
                trigger: topFirstSection,
                start: 'top top-=10%',

                onEnter() {
                    tlTopDecor.timeScale(1).play()
                },
                onEnterBack() {
                    tlTopDecor.timeScale(1).play()
                },
                onLeave() {
                    tlTopDecor.timeScale(2.5).reverse()
                },
                onLeaveBack() {
                    tlTopDecor.timeScale(2.5).reverse()
                },
            })


            gsap.timeline({
                scrollTrigger: {
                    trigger: topFirstSection,
                    scrub: true,
                    start: 'top top',
                    end: () => '+=' + (topFirstSectionRect.height - topStickySection.height),
                }
            })
                .to('.wrapper_heading_top', {
                    y: '-5vw',
                    scaleY:.9,
                    ease: 'none',
                }, '<')
                .to('.wrappr_texts_top', {
                    y: '-15vw',
                    ease: 'none',
                }, '<')
                .to('.phone-girl-top', {
                    y: 0,
                    ease: 'none',
                }, '<')
                .to('.top-girl-background :is(.video_wrapper,.backdrop_video)', {
                    autoAlpha: 0,
                    scale: 1,
                    ease: 'none',
                }, '<')
                .to('.top-text-1', {
                    x: 0,
                    ease: 'none',
                }, '<')
                .to('.top-text-2', {
                    x: 0,
                    scale: 0.8,
                    transformOrigin: 'bottom left',
                    ease: 'none',
                }, '<')


            gsap.timeline({
                scrollTrigger: {
                    trigger: topFirstSection,
                    scrub: true,
                    start: 'bottom bottom',
                    end:'+=70%'
                }
            })
                .to('.big-top-title', {
                    y:'10vw',
                    autoAlpha:0,
                    filter: 'blur(30px)',
                    ease: 'none',
                }, '<')
            gsap.timeline({
                scrollTrigger: {
                    trigger: topFirstSection,
                    scrub: true,
                    start: 'top top',
                    end: () => '+=' + (topFirstSectionRect.height),
                }
            })
                .to('.item-decor-top svg', {
                    rotate: 45,
                    ease: 'none',
                }, '<')
        }else {
            const text_mobile_descr = document.querySelector('.text_mobile_descr')
            const text_mobile_descrRect = text_mobile_descr.getBoundingClientRect()
            gsap.set(topFirstSection, {height: windowHeight + text_mobile_descrRect.height})

            const stickySection = topFirstSection.querySelector('.top-sticky-section')
            const topFirstSectionRect = topFirstSection.getBoundingClientRect()
            const topStickySection = stickySection.getBoundingClientRect()

            gsap.set('.top-decor-1', {rotate:45,scale:.3,autoAlpha:0,transformOrigin:'center'})
            gsap.set('.top-decor-3', {rotate:-45,scale:.3,autoAlpha:0,transformOrigin:'center'})
            gsap.set('.top-decor-2', {scaleY:0,scaleX:.9,rotate:-2,transformOrigin:'center top'})

            const tlTopDecor = gsap.timeline({ paused: true })

            tlTopDecor
                .to('.top-decor-1', {
                    scale:1,
                    rotate:0,
                    autoAlpha:1,
                    duration: .3,
                    ease: 'none'
                }, '<')
                .to('.top-decor-3', {
                    scale:1,
                    rotate:0,
                    autoAlpha:1,
                    duration: .3,
                    ease: 'none'
                }, '<')
                .to('.top-decor-2', {
                    scaleY:1,
                    scaleX:1,
                    y:0,
                    rotate:0,
                    autoAlpha: 1,
                    duration: .3,
                    ease: 'none'
                }, '<+=.2')


            ScrollTrigger.create({
                trigger: topFirstSection,
                start: 'top top-=10%',

                onEnter() {
                    tlTopDecor.timeScale(1).play()
                },
                onEnterBack() {
                    tlTopDecor.timeScale(1).play()
                },
                onLeave() {
                    tlTopDecor.timeScale(2.5).reverse()
                },
                onLeaveBack() {
                    tlTopDecor.timeScale(2.5).reverse()
                },
            })


            gsap.timeline({
                scrollTrigger: {
                    trigger: topFirstSection,
                    scrub: true,
                    start: 'top top',
                    end: () => '+=' + (topFirstSectionRect.height - topStickySection.height),
                }
            })
                .to('.top-girl-background :is(.video_wrapper,.backdrop_video)', {
                    autoAlpha: 0,
                    scale: 1,
                    ease: 'none',
                }, '<')
                .from('.mobile_top_video', {
                    y: 109,
                    scale:.9,
                    ease: 'none',
                }, '<')
                .from('.mobile_top_descr', {
                    y: -109,
                    ease: 'none',
                }, '<')
        }
    }

    const secondSection = document.getElementById('second_section')
    const youSectionChild = document.getElementById('you-section-child')
    if(secondSection && windowWidth >= 1280) {
        gsap.timeline({
            scrollTrigger: {
                trigger: secondSection,
                scrub: true,
                start: `top top`,
                end: `+=120%`,
            }
        })
            .to('.headings_you', {
                y: '-10vw',
                scale: .9,
                autoAlpha:0,
                ease: 'none',
            }, '<')
            .to('.big-stars-you', {
                top: '40vw',
                ease: 'none',
            }, '<')
            .to('.video-you', {
                y: 0,
                scale:1,
                ease: 'none',
            }, '<')

        const card_you_1 = document.querySelector('.card_you_1')
        if(card_you_1) {
            card_you_1.addEventListener('mouseover', () => {
                gsap.to('.star_decor', {rotate:90,scale:1.3,y:'-1vw',x:'1vw',ease:'power2'})
                gsap.to('.line_decor_1', {scale:1,rotate:-30,y:'0.5vw',transformOrigin:'bottom left',ease:'power2'})
            })
            card_you_1.addEventListener('mouseleave', () => {
                gsap.to('.star_decor', {rotate:0,scale:1,y:0,x:0,ease:'power2'})
                gsap.to('.line_decor_1', {scale:1,rotate:0,y:0,x:0,ease:'power2'})
            })
        }

        const card_you_2 = document.querySelector('.card_you_2')
        if(card_you_2) {
            card_you_2.addEventListener('mouseover', () => {
                gsap.to('.decor_lines_four', {scale:.9,ease:'power2'})

                gsap.to('.decor_weather_1 path', {scale:1.14,rotate:10,transformOrigin:'center bottom',ease:'power2'})
                gsap.to('.decor_weather_2 path', {scale:1.14,rotate:-5,transformOrigin:'center bottom',ease:'power2'})
                // gsap.to('.decor_weather_1 path:nth-child(2)', {x:'0vw',rotate:180,transformOrigin:'center',ease:'power2'})
                // gsap.to('.decor_weather_1 path:nth-child(3)', {x:'0.5vw',rotate:180,transformOrigin:'center',ease:'power2'})
                // gsap.to('.decor_weather_1 path:nth-child(4)', {transformOrigin:'center',ease:'power2'})

                // gsap.to('.decor_weather_2 path:nth-child(1)', {rotate:-360,duration:1,transformOrigin:'center',ease:'power2'})
                // gsap.to('.decor_weather_2 path:nth-child(2)', {rotate:-360,duration:1,transformOrigin:'center',ease:'power2'})
                // gsap.to('.decor_weather_2 path:nth-child(3)', {rotate:-360,duration:1,transformOrigin:'center',ease:'power2'})
                // gsap.to('.decor_weather_2 path:nth-child(4)', {scale:1,transformOrigin:'center',ease:'power2'})
            })
            card_you_2.addEventListener('mouseleave', () => {
                gsap.to('.decor_lines_four', {rotate:0,scale:1,y:0,x:0,ease:'power2'})

                gsap.to('.decor_weather_1 path', {rotate:0,scale:1,y:0,x:0,ease:'power2'})
                gsap.to('.decor_weather_2 path', {rotate:0,scale:1,y:0,x:0,ease:'power2'})
                // gsap.to('.decor_weather_1 path:nth-child(2)', {rotate:0,scale:1,y:0,x:0,ease:'power2'})
                // gsap.to('.decor_weather_1 path:nth-child(3)', {rotate:0,scale:1,y:0,x:0,ease:'power2'})
                // gsap.to('.decor_weather_1 path:nth-child(4)', {rotate:0,scale:1,y:0,x:0,ease:'power2'})

                // gsap.to('.decor_weather_2 path:nth-child(1)', {rotate:0,scale:1,y:0,x:0,ease:'power2'})
                // gsap.to('.decor_weather_2 path:nth-child(2)', {rotate:0,scale:1,y:0,x:0,ease:'power2'})
                // gsap.to('.decor_weather_2 path:nth-child(3)', {rotate:0,scale:1,y:0,x:0,ease:'power2'})
                // gsap.to('.decor_weather_2 path:nth-child(4)', {rotate:0,scale:1,y:0,x:0,ease:'power2'})
            })
        }

        const card_you_3 = document.querySelector('.card_you_3')
        if(card_you_3) {
            card_you_3.addEventListener('mouseover', () => {
                gsap.to('.heart_1', {rotate:-35,scale:1.2,x:'-2vw',y:'-1vw',ease:'power2'})
                gsap.to('.heart_2', {rotate:10,scale:1.2,y:'-4vw',x:'1vw',ease:'power2'})

                gsap.to('.lines_decor_1 path', {scale:.8,transformOrigin:'center bottom',ease:'power2'})
                gsap.to('.lines_decor_2 path', {scale:1.2,transformOrigin:'left bottom',ease:'power2'})
            })
            card_you_3.addEventListener('mouseleave', () => {
                gsap.to('.heart_1', {rotate:0,scale:1,y:0,x:0,ease:'power2'})
                gsap.to('.heart_2', {rotate:0,scale:1,y:0,x:0,ease:'power2'})

                gsap.to('.lines_decor_1 path', {rotate:0,scale:1,y:0,x:0,ease:'power2'})
                gsap.to('.lines_decor_2 path', {rotate:0,scale:1,y:0,x:0,ease:'power2'})
            })
        }

        const card_you_4 = document.querySelector('.card_you_4')
        if(card_you_4) {
            card_you_4.addEventListener('mouseover', () => {
                gsap.to('.lines_decor_th_1', {rotate:-10,transformOrigin:'center bottom',ease:'power2'})
                gsap.to('.lines_decor_th_1 path', {scale:.9,transformOrigin:'center bottom',ease:'power2'})
                gsap.to('.lines_decor_th_2 path', {scale:1.1,rotate:10,transformOrigin:'center bottom',ease:'power2'})
            })
            card_you_4.addEventListener('mouseleave', () => {
                gsap.to('.lines_decor_th_1', {rotate:0,scale:1,y:0,x:0,ease:'power2'})
                gsap.to('.lines_decor_th_1 path', {rotate:0,scale:1,y:0,x:0,ease:'power2'})
                gsap.to('.lines_decor_th_2 path', {scaleY:1,rotate:0,y:0,x:0,ease:'power2'})
            })
        }
    }

    const streaming = document.getElementById('streaming')
    if(streaming) {
        if (windowWidth >= 1280) {
            gsap.timeline({
                scrollTrigger: {
                    trigger: streaming,
                    scrub: 1,
                    start: `top top+=100%`,
                    end: `+=200%`,
                }
            })
                .to('.first_step_decor_1', {
                    scale: 1.2,
                    rotate:10,
                    ease: 'none',
                }, '<')
                .from('.first_step_decor_2', {
                    rotate:20,
                    scale:1.1,
                    ease: 'none',
                }, '<')

            const decorStep2Children = gsap.utils.toArray('.decor_step_2 > img, .decor_step_2 > svg')
            const decorStep3Children = gsap.utils.toArray('.decor_step_3 > svg')
            decorStep2Children.forEach(el => { el._rndRotate = gsap.utils.random(-40, 40, 30) })
            decorStep3Children.forEach(el => { el._rndRotate = gsap.utils.random(40, 80, 40) })

            gsap.timeline({
                scrollTrigger: {
                    trigger: streaming,
                    scrub: 2,
                    start: 'top+=25% top',
                    end: '+=200%',
                }
            })
                .to(decorStep2Children, {rotate: (i, target) => target._rndRotate,scale:1.1,ease: 'none'}, '<')

            gsap.timeline({
                scrollTrigger: {
                    trigger: streaming,
                    scrub: 2,
                    start: 'top+=50% top',
                    end: '+=200%',
                }
            })
                .to(decorStep3Children, {rotate: (i, target) => target._rndRotate,scale:1.1,ease: 'none'}, '<')

            const stepGroups = [
                streaming.querySelectorAll('.decor_step_1'),
                streaming.querySelectorAll('.decor_step_2'),
                streaming.querySelectorAll('.decor_step_3'),
            ]

            stepGroups.forEach(group => {
                gsap.set(group, {
                    autoAlpha: 0,
                    scale: (i, target) => target.getAttribute('data-scale') || 0,
                    y: (i, target) => target.getAttribute('data-y') || 0,
                    x: (i, target) => target.getAttribute('data-x') || 0,
                })
            })

            const stepButtons = streaming.querySelectorAll('.item_stram_g')
            const activeStreaming = streaming.querySelector('.active_streaming')
            const initialBodyBg = '#FF0381'
            gsap.set(streaming, { height: windowHeight * 5 })

            function showStep(index) {
                stepGroups.forEach((group, i) => {
                    const isActive = i === index

                    gsap.to(group, {
                        autoAlpha: isActive ? 1 : 0,
                        scale: (j, target) => isActive ? 1 : (target.getAttribute('data-scale') || .3),
                        x: (j, target) => isActive ? 0 : (target.getAttribute('data-x') || 0),
                        y: (j, target) => {
                            const baseY = isActive ? 0 : (target.getAttribute('data-y') || 0)
                            return isActive ? baseY : baseY
                        },
                        duration: isActive ? 1 : 0.3,
                        ease: isActive ? 'bounce2' : 'power1.inOut',
                        overwrite: 'auto',
                    })
                })

                let bgColor = initialBodyBg
                if (index === 1) bgColor = '#234851'
                else if (index === 2) bgColor = '#010101'

                gsap.to(mainWrapper, {
                    backgroundColor: bgColor,
                    duration: 0.6,
                    overwrite: 'auto',
                    ease: 'power2.out',
                })
            }

            function moveActiveStreamingTo(index, immediate = false) {
                if (!activeStreaming) return

                const targetBtn = [...stepButtons].find(btn => {
                    const btnStepIndex = (parseInt(btn.dataset.step, 10) || 1) - 1
                    return btnStepIndex === index
                })

                if (!targetBtn) return

                const y = targetBtn.offsetTop
                const height = targetBtn.offsetHeight

                const vars = {
                    y,
                    height,
                    overwrite: 'auto',
                    duration: immediate ? 0 : 0.25,
                }

                if (immediate) {
                    gsap.set(activeStreaming, vars)
                } else {
                    gsap.to(activeStreaming, vars)
                }
            }

            function applyStepFromScroll(index, immediateHighlight = false) {
                streaming._currentStep = index
                showStep(index)

                stepButtons.forEach(btn => {
                    const btnStepIndex = (parseInt(btn.dataset.step, 10) || 1) - 1
                    btn.classList.toggle('current', btnStepIndex === index)
                })

                moveActiveStreamingTo(index, immediateHighlight)
            }

            function scrollToStep(index) {
                const st = streaming._stepsTrigger
                if (!st) return

                const centers = [1 / 6, 0.5, 5 / 6]
                const progress = centers[index] ?? 0
                const targetY = st.start + (st.end - st.start) * progress
                scroll.scrollTo(targetY, {duration: .1, immediate: true})
            }

            streaming._currentStep = 0
            applyStepFromScroll(0, true)

            stepButtons.forEach(btn => {
                btn.addEventListener('click', () => {
                    const stepIndex = (parseInt(btn.dataset.step, 10) || 1) - 1
                    scrollToStep(stepIndex)
                })
            })

            const stepsTrigger = ScrollTrigger.create({
                trigger: streaming,
                start: 'top top',
                end: `+=${windowHeight * 4}`,
                onUpdate: (self) => {
                    const p = self.progress
                    let stepIndex

                    if (p < 1 / 3) {
                        stepIndex = 0
                    } else if (p < 2 / 3) {
                        stepIndex = 1
                    } else {
                        stepIndex = 2
                    }

                    if (stepIndex !== streaming._currentStep) {
                        applyStepFromScroll(stepIndex)
                    }
                }
            })

            ScrollTrigger.create({
                trigger: streaming,
                start: 'top top',
                end: 'bottom top',
                onToggle(self) {
                    disableBackgroundColor = self.isActive
                }
            })


            gsap.set('.legend_streaming', {autoAlpha:0,scale:.8,xPercent:100})
            ScrollTrigger.create({
                trigger: streaming,
                start: 'top top',
                end: 'bottom bottom',
                onToggle(self) {
                    gsap.to('.legend_streaming', {autoAlpha:1,scale:1,xPercent:0})
                },
                onLeave(self) {
                    gsap.to('.legend_streaming', {autoAlpha:0,scale:.8,xPercent:100})
                },
                onLeaveBack(self) {
                    gsap.to('.legend_streaming', {autoAlpha:0,scale:.8,xPercent:100})
                }
            })

            streaming._stepsTrigger = stepsTrigger

            ScrollTrigger.addEventListener('refresh', () => {
                if (!streaming || !streaming._currentStep && streaming._currentStep !== 0) return
                moveActiveStreamingTo(streaming._currentStep, true)
            })
            ScrollTrigger.refresh()
        }else {
            if (streaming) {
                const stepGroups = [
                    streaming.querySelectorAll('.decor_step_1'),
                    streaming.querySelectorAll('.decor_step_2'),
                    streaming.querySelectorAll('.decor_step_3'),
                ]

                stepGroups.forEach(group => {
                    gsap.set(group, {
                        autoAlpha: 0,
                        scale: (i, target) => target.getAttribute('data-scale') || 0,
                        y: (i, target) => target.getAttribute('data-y') || 0,
                        x: (i, target) => target.getAttribute('data-x') || 0,
                    })
                })

                const stepButtons = Array.from(streaming.querySelectorAll('.item_stram_g'))
                const activeStreaming = streaming.querySelector('.active_streaming')
                const initialBodyBg = '#FF0381'

                const clamp = (v, a, b) => Math.max(a, Math.min(b, v))
                const lerp = (a, b, t) => a + (b - a) * t

                function showStep(index) {
                    stepGroups.forEach((group, i) => {
                        const isActive = i === index
                        gsap.to(group, {
                            autoAlpha: isActive ? 1 : 0,
                            scale: (j, target) => (isActive ? 1 : (target.getAttribute('data-scale') || 0.3)),
                            x: (j, target) => (isActive ? 0 : (target.getAttribute('data-x') || 0)),
                            y: (j, target) => (isActive ? 0 : (target.getAttribute('data-y') || 0)),
                            duration: isActive ? 1 : 0.3,
                            ease: isActive ? 'bounce2' : 'power1.inOut',
                            overwrite: 'auto',
                        })
                    })

                    let bgColor = initialBodyBg
                    if (index === 1) bgColor = '#234851'
                    else if (index === 2) bgColor = '#010101'

                    gsap.to(mainWrapper, {
                        backgroundColor: bgColor,
                        duration: 0.6,
                        overwrite: 'auto',
                        ease: 'power2.out',
                    })
                }

                let btnRects = []
                let axis = 'x'

                function measureButtons() {
                    btnRects = stepButtons.map(btn => ({
                        x: btn.offsetLeft,
                        y: btn.offsetTop,
                        w: btn.offsetWidth,
                        h: btn.offsetHeight,
                    }))

                    if (btnRects.length > 1) {
                        const y0 = btnRects[0].y
                        const sameRow = btnRects.every(r => Math.abs(r.y - y0) <= 2)
                        axis = sameRow ? 'x' : 'y'
                    } else {
                        axis = 'x'
                    }
                }

                function setPillToIndex(idx) {
                    if (!activeStreaming || !btnRects.length) return
                    const r = btnRects[clamp(idx, 0, btnRects.length - 1)]
                    if (axis === 'y') gsap.set(activeStreaming, { y: r.y, height: r.h })
                    else gsap.set(activeStreaming, { x: r.x, width: r.w })
                }

                function setPillBetween(aIdx, bIdx, t) {
                    if (!activeStreaming || btnRects.length < 2) return
                    const a = btnRects[aIdx]
                    const b = btnRects[bIdx]
                    t = clamp(t, 0, 1)
                    if (axis === 'y') {
                        gsap.set(activeStreaming, {
                            y: lerp(a.y, b.y, t),
                            height: lerp(a.h, b.h, t),
                        })
                    } else {
                        gsap.set(activeStreaming, {
                            x: lerp(a.x, b.x, t),
                            width: lerp(a.w, b.w, t),
                        })
                    }
                }

                function applyStepFromScroll(index) {
                    streaming._currentStep = index
                    showStep(index)
                }

                function setScrollArea() {
                    const vh = window.innerHeight
                    streaming.style.minHeight = `${Math.ceil(vh * 4.0)}px`
                }

                function scrollToStep(index) {
                    const st = streaming._stepsTrigger
                    if (!st) return

                    const step1End = 0.28
                    const step2End = 0.58

                    const pTarget = index === 0 ? 0 : (index === 1 ? step1End : step2End)
                    const targetY = st.start + (st.end - st.start) * pTarget
                    scroll.scrollTo(targetY, { duration: 0.2, immediate: true })
                }

                function updateActiveStreaming(p) {
                    if (!activeStreaming || btnRects.length < 2) return

                    const t1 = 0.22
                    const t2 = 0.32
                    const t3 = 0.52
                    const t4 = 0.62

                    const pts = [
                        [0.00, 0.00],
                        [t1, 0.10],
                        [t2, 1.00],
                        [t3, 1.10],
                        [t4, 2.00],
                        [1.00, 2.00],
                    ]

                    p = clamp(p, 0, 1)

                    let u = 0
                    for (let k = 0; k < pts.length - 1; k++) {
                        const a = pts[k], b = pts[k + 1]
                        if (p >= a[0] && p <= b[0]) {
                            const tt = (p - a[0]) / (b[0] - a[0] || 1)
                            u = lerp(a[1], b[1], tt)
                            break
                        }
                    }

                    const i = clamp(Math.floor(u), 0, btnRects.length - 2)
                    const tt = u - i
                    setPillBetween(i, i + 1, tt)
                }


                setScrollArea()
                measureButtons()

                streaming._currentStep = -1
                applyStepFromScroll(0)
                setPillToIndex(0)

                const stepsTrigger = ScrollTrigger.create({
                    trigger: streaming,
                    start: 'top top',
                    end: () => `+=${Math.ceil(window.innerHeight * 4.8)}`,
                    // end: () => `+=${Math.ceil(window.innerHeight * 4.0)}`,
                    onUpdate: (self) => {
                        const p = self.progress

                        const pStep2 = 0.30
                        const pStep3 = 0.60

                        const stepIndex = p < pStep2 ? 0 : (p < pStep3 ? 1 : 2)
                        if (stepIndex !== streaming._currentStep) applyStepFromScroll(stepIndex)

                        updateActiveStreaming(p)
                    }
                })

                streaming._stepsTrigger = stepsTrigger

                stepButtons.forEach(btn => {
                    btn.addEventListener('click', (e) => {
                        e.preventDefault()

                        const st = streaming._stepsTrigger
                        if (!st) return

                        const stepIndex = (parseInt(btn.dataset.step, 10) || 1) - 1

                        const p1 = 0.00
                        const p2 = 0.32
                        const p3 = 0.62

                        const pTarget = stepIndex === 0 ? p1 : (stepIndex === 1 ? p2 : p3)

                        const targetY = st.start + (st.end - st.start) * pTarget

                        scroll.scrollTo(targetY, {
                            duration: 0.6,
                            immediate: false,
                            lock: true,
                            force: true,
                        })
                    })
                })

                ScrollTrigger.create({
                    trigger: streaming,
                    start: 'top top',
                    end: 'bottom top',
                    onToggle(self) {
                        disableBackgroundColor = self.isActive
                    }
                })

                ScrollTrigger.addEventListener('refreshInit', () => {
                    setScrollArea()
                    measureButtons()
                })

                ScrollTrigger.addEventListener('refresh', () => {
                    setScrollArea()
                    measureButtons()
                    if (!streaming._stepsTrigger) return

                    const p = streaming._stepsTrigger.progress

                    const pStep2 = 0.30
                    const pStep3 = 0.60
                    const stepIndex = p < pStep2 ? 0 : (p < pStep3 ? 1 : 2)
                    if (stepIndex !== streaming._currentStep) applyStepFromScroll(stepIndex)

                    updateActiveStreaming(p)
                })

                ScrollTrigger.refresh()
            }
        }
    }

    const videoSection = document.getElementById('video-section')
    if(videoSection) {
        const rectVideoSection = videoSection.getBoundingClientRect()
        gsap.timeline({
            scrollTrigger: {
                trigger: videoSection,
                scrub: true,
                start: `top bottom`,
                end: `+=150%`,
            }
        })
            .to('.video-wrapper', {
                scale: 1,
                ease: 'none',
            })

        gsap.timeline({
            scrollTrigger: {
                trigger: videoSection,
                scrub: true,
                start: `top bottom-=70%`,
                end: `+=70%`,
            }
        })
            .to('.video-wrapper', {
                borderColor: 'transparent',
                borderRadius: 0,
                ease: 'none',
            })
        gsap.timeline({
            scrollTrigger: {
                trigger: videoSection,
                scrub: true,
                start: `top bottom-=150%`,
                end: `+=50%`,
            }
        })
            .to('.video-wrapper', {
                scale: 1.05,
                filter: 'blur(10px)',
                ease: 'none',
            }, '<')
            .to('.video-bg-scale', {
                autoAlpha: .5,
                ease: 'none',
            }, '<')
    }

    const blockExamples = document.getElementById('block_examples')
    if(blockExamples) {
        if(windowWidth >= 1280) {
            const horizontalExamples = document.querySelector('.horizontal_examples')
            const itemExample = blockExamples.querySelectorAll('.item_exampl')
            if(itemExample.length > 2) {
                gsap.set(blockExamples, {height:(itemExample.length - 1) * windowHeight})
                gsap.set(itemExample, {transformOrigin:'left'})

                const rectBlockExample = blockExamples.getBoundingClientRect()
                const rectHorizontalExample = horizontalExamples.getBoundingClientRect()

                const tlExamples = gsap.timeline({
                    scrollTrigger: {
                        trigger: blockExamples,
                        scrub: true,
                        start: 'top top',
                        end: `+=${rectBlockExample.height - windowHeight}`
                    }
                })
                tlExamples.to(horizontalExamples, {
                    x: -(rectHorizontalExample.width - rectHorizontalExample.left - (rectBlockExample.left * 2)),
                    ease: 'none',
                }, 0)

                gsap.timeline({
                    scrollTrigger: {
                        trigger: blockExamples,
                        scrub: true,
                        start: 'top 140%',
                        end: `+=140%`
                    }
                })
                    .from('.wrapper_horiz_exmpl', {
                        yPercent: -40,
                        left: '40%',
                        scale:.9,
                        ease: 'none',
                    })
            }
        }else {
            const horizontalExamples = document.querySelector('.horizontal_examples')
            const itemExample = blockExamples.querySelectorAll('.item_exampl')
            if(itemExample.length > 2) {
                gsap.set(blockExamples, {height:(itemExample.length - 1) * windowHeight})
                gsap.set(itemExample, {transformOrigin:'left'})

                const rectBlockExample = blockExamples.getBoundingClientRect()
                const rectHorizontalExample = horizontalExamples.getBoundingClientRect()

                const tlExamples = gsap.timeline({
                    scrollTrigger: {
                        trigger: blockExamples,
                        scrub: true,
                        start: 'top top',
                        end: `bottom bottom`
                    }
                })
                tlExamples.to(horizontalExamples, {
                    x: -(rectHorizontalExample.width - (windowWidth - (rectHorizontalExample.left + rectBlockExample.left))),
                    ease: 'none',
                })
            }
        }
    }

    const soloWithUs = document.getElementById('solo_with_us')
    if (soloWithUs) {
        if(windowWidth >= 1280) {
            const itemsSolo = gsap.utils.toArray('.badges-wrap-1 .item_badg_g')
            const itemsSolo2 = gsap.utils.toArray('.badges-wrap-2 .item_badg_g')
            gsap.set(soloWithUs, {height:windowHeight * 7})

            const idleStyle = {
                fontSize: '3.4vw',
                backgroundColor: '#397684'
            }

            const activeStyle = {
                fontSize: '7.222222222222221vw',
                backgroundColor: '#1D5A68'
            }

            gsap.set(itemsSolo, {...idleStyle,transformOrigin:'50% 50%'})

            let currentIndex = -1

            function animateToIdle(index) {
                if (index < 0) return
                const el = itemsSolo[index]
                gsap.killTweensOf(el)
                gsap.to(el, {
                    ...idleStyle,
                    duration: 0.4,
                    ease: 'power2.out'
                })
            }

            const st1 = ScrollTrigger.create({
                trigger: soloWithUs,
                start: 'top top',
                end: `+=300%`,
                scrub: true,
                onUpdate(self) {
                    if (!self.isActive) return

                    const index = Math.round(self.progress * (itemsSolo.length - 1))
                    if (index === currentIndex) return

                    const newEl = itemsSolo[index]
                    const oldEl = currentIndex >= 0 ? itemsSolo[currentIndex] : null

                    gsap.killTweensOf([newEl, oldEl])

                    if (oldEl) {
                        gsap.to(oldEl, {
                            ...idleStyle,
                            duration: 0.3,
                            ease: 'power2.out'
                        })
                    }

                    gsap.to(newEl, {
                        ...activeStyle,
                        duration: 0.5,
                        ease: 'osmoBounce'
                    })

                    currentIndex = index
                },
                onLeave(self) {
                    animateToIdle(currentIndex)
                    currentIndex = -1
                },
                onLeaveBack(self) {
                    animateToIdle(currentIndex)
                    currentIndex = -1
                }
            })

            let isYellow = false
            const tl2 = gsap.timeline({
                scrollTrigger: {
                    trigger: soloWithUs,
                    scrub: true,
                    start: () => st1.end,
                    end: `+=100%`,
                    onUpdate(self) {
                        if (self.progress > 0.3 && !isYellow) {
                            isYellow = true
                            gsap.to('#solo_section', {duration:0.3,overwrite:true,backgroundColor:'#C2FF0D',ease:'power1.inOut'})

                            gsap.to('.item_titl_sol:first-child', {duration:0.3,overwrite:true,color:'#666366',ease:'power1.inOut'})
                            gsap.to('.item_titl_sol:last-child', {duration:0.3,overwrite:true,color:'#FF03FF',ease:'power1.inOut'})
                        } else if (self.progress <= 0.3 && isYellow) {
                            isYellow = false
                            gsap.to('#solo_section', {duration:0.3,overwrite:true,backgroundColor:'#010101',ease:'power1.inOut'})

                            gsap.to('.item_titl_sol:first-child', {duration:0.3,overwrite:true,color:'#C2FF0D',ease:'power1.inOut'})
                            gsap.to('.item_titl_sol:last-child', {duration:0.3,overwrite:true,color:'#666366',ease:'power1.inOut'})
                        }
                    }
                }
            })
                .to('.headings-with-us', {
                    x: 0,
                    ease: 'none',
                }, '<')
                .to('.badges-wrap-1', {
                    autoAlpha:0,
                    ease: 'none',
                }, '<')
                .to('.badges-wrap-1 > div', {
                    x: -200,
                    scale:.5,
                    autoAlpha:0,
                    stagger: .1,
                    ease: 'none',
                }, '<')
                .from('.badges-wrap-2 > div', {
                    x: 40,
                    scale:.9,
                    stagger: .02,
                    autoAlpha:0,
                    ease: 'none',
                }, '<+=.5')

            const idleStyle2 = {
                fontSize: '3.4vw',
                backgroundColor: '#FF03FF'
            }

            const activeStyle2 = {
                fontSize: '7.222222222222221vw',
                backgroundColor: '#A80FA8'
            }

            gsap.set(itemsSolo2, {...idleStyle2,transformOrigin:'50% 50%'})
            let currentIndex2 = -1

            function animateToIdle2(index) {
                if (index < 0) return
                const el = itemsSolo2[index]
                gsap.killTweensOf(el)
                gsap.to(el, {
                    ...idleStyle2,
                    duration: 0.4,
                    ease: 'power2.out'
                })
            }

            const st2 = tl2.scrollTrigger
            ScrollTrigger.create({
                trigger: soloWithUs,
                start: 'top top-=400%',
                end: `+=250%`,
                scrub: true,
                onUpdate(self) {
                    if (!self.isActive) return

                    const index = Math.round(self.progress * (itemsSolo2.length - 1))
                    if (index === currentIndex2) return

                    const newEl = itemsSolo2[index]
                    const oldEl = currentIndex2 >= 0 ? itemsSolo2[currentIndex2] : null

                    gsap.killTweensOf([newEl, oldEl])

                    if (oldEl) {
                        gsap.to(oldEl, {
                            ...idleStyle2,
                            duration: 0.3,
                            ease: 'power2.out'
                        })
                    }

                    gsap.to(newEl, {
                        ...activeStyle2,
                        duration: 0.5,
                        ease: 'osmoBounce'
                    })

                    currentIndex2 = index
                },
                onLeave(self) {
                    animateToIdle2(currentIndex2)
                    currentIndex2 = -1
                },
                onLeaveBack(self) {
                    animateToIdle2(currentIndex2)
                    currentIndex2 = -1
                }
            })

            gsap.timeline({
                scrollTrigger: {
                    trigger: soloWithUs,
                    scrub: true,
                    start: `top top-=400%`,
                    end: `+=200%`
                }
            })
                .to(soloWithUs, {
                    y: '-20vw',
                    ease: 'none',
                })
        }else {
            let isYellow = false
            gsap.set(soloWithUs, {height:windowHeight * 2})

            const tl2 = gsap.timeline({
                scrollTrigger: {
                    trigger: soloWithUs,
                    scrub: true,
                    start: 'top top',
                    end: `bottom bottom`,
                    onUpdate(self) {
                        if (self.progress > 0.3 && !isYellow) {
                            isYellow = true
                            gsap.to('#solo_section', {duration:0.3,overwrite:true,backgroundColor:'#C2FF0D',ease:'power1.inOut'})

                            gsap.to('.item_titl_sol:first-child', {duration:0.3,overwrite:true,color:'#666366',ease:'power1.inOut'})
                            gsap.to('.item_titl_sol:last-child', {duration:0.3,overwrite:true,color:'#FF03FF',ease:'power1.inOut'})
                        } else if (self.progress <= 0.3 && isYellow) {
                            isYellow = false
                            gsap.to('#solo_section', {duration:0.3,overwrite:true,backgroundColor:'#010101',ease:'power1.inOut'})

                            gsap.to('.item_titl_sol:first-child', {duration:0.3,overwrite:true,color:'#C2FF0D',ease:'power1.inOut'})
                            gsap.to('.item_titl_sol:last-child', {duration:0.3,overwrite:true,color:'#666366',ease:'power1.inOut'})
                        }
                    }
                }
            })
                .to('.badges-wrap-1', {
                    autoAlpha:0,
                    ease: 'none',
                }, '<')
                .to('.badges-wrap-1 > div', {
                    x: -200,
                    scale:.5,
                    autoAlpha:0,
                    stagger: .1,
                    ease: 'none',
                }, '<')
                .from('.badges-wrap-2 > div', {
                    x: 40,
                    scale:.9,
                    stagger: .1,
                    autoAlpha:0,
                    ease: 'none',
                }, '<+=.5')
        }
    }

    const reviewsLive = document.getElementById('reviews_live')
    if (reviewsLive) {
        const cards  = gsap.utils.toArray('.item_review_go')
        const titles = gsap.utils.toArray('.item_publ_g')
        if(windowWidth >= 1280) {
            gsap.set(reviewsLive, { height: cards.length * windowHeight })

            gsap.timeline({
                scrollTrigger: {
                    trigger: reviewsLive,
                    scrub: true,
                    start: 'top bottom',
                    end: 'bottom bottom',
                }
            })
                .to('.wrapper_reviews_g', {
                    y: 0,
                    ease: 'none',
                }, '<')

            function setCurrentTab(index) {
                titles.forEach((el, i) => {
                    el.classList.toggle('current', i === index)
                })
            }

            const stepLabels = ['tab1', 'tab2', 'tab3']
            let stepEdges = null

            const tlReviews = gsap.timeline({
                scrollTrigger: {
                    trigger: reviewsLive,
                    scrub: true,
                    start: 'top center',
                    end: 'bottom bottom',
                    onUpdate: self => {
                        if (!stepEdges) {
                            const times = stepLabels.map(label => tlReviews.labels[label])
                            const dur = tlReviews.duration()

                            stepEdges = []
                            stepEdges[0] = 0

                            for (let i = 0; i < times.length - 1; i++) {
                                stepEdges[i + 1] = (times[i] + times[i + 1]) / 2
                            }

                            stepEdges[stepLabels.length] = dur
                        }

                        const dur = self.animation.duration()
                        const tRaw = self.animation.time()
                        const t = Math.min(tRaw, dur - 0.0001)

                        let activeIndex = 0
                        for (let i = 0; i < stepEdges.length - 1; i++) {
                            if (t >= stepEdges[i] && t < stepEdges[i + 1]) {
                                activeIndex = i
                                break
                            }
                        }

                        setCurrentTab(activeIndex)
                    }
                }
            })
            tlReviews
                .from(cards[0], {
                    yPercent: 100,
                    rotateX: 40,
                    rotate: 10,
                    ease: 'none',
                })
                .addLabel('tab1')
                .to(cards[0], {
                    backgroundColor: '#ECFFB4',
                    ease: 'none',
                }, '>')
                .from(cards[1], {
                    yPercent: 200,
                    rotateX: 40,
                    rotate: 10,
                    ease: 'none',
                }, '>-=.63')
                .addLabel('tab2')
                .to(cards[1], {
                    backgroundColor: '#ECFFB4',
                    ease: 'none',
                }, '>')
                .from(cards[2], {
                    yPercent: 200,
                    rotateX: 40,
                    rotate: 10,
                    ease: 'none',
                }, '>-=.63')
                .addLabel('tab3')

            titles.forEach((title) => {
                title.addEventListener('click', () => {
                    const tabIndex1based = Number(title.dataset.isTabl)
                    const tabIndex0based = tabIndex1based - 1
                    const label = `tab${tabIndex1based}`

                    setCurrentTab(tabIndex0based)
                    scrollToLabel(tlReviews, label)
                })
            })

            function scrollToLabel(tl, label) {
                const st = tl.scrollTrigger
                if (!st) return

                const labelTime = tl.labels[label]
                if (labelTime == null) return

                const progress = labelTime / tl.duration()
                const scrollY = st.start + (st.end - st.start) * progress

                scroll.scrollTo(scrollY, { duration: 1.5 })
            }
        }else {
            const heading_reviews_facts = document.getElementById('heading_reviews_facts')
            const heading_reviews_factsRect = heading_reviews_facts.getBoundingClientRect()

            const sticky_reviews_live = document.getElementById('sticky_reviews_live')
            const reviewsLiveStyle = window.getComputedStyle(sticky_reviews_live)
            const topStyleValueReviews = parseInt(reviewsLiveStyle.top)


            gsap.set(reviewsLive, { height: cards.length * windowHeight })
            const tlReviews = gsap.timeline({
                scrollTrigger: {
                    trigger: reviewsLive,
                    scrub: true,
                    start: 'top center',
                    end: 'bottom bottom'
                }
            })
            tlReviews
                .from(cards[0], {
                    yPercent: 100,
                    rotateX: 40,
                    rotate: 10,
                    ease: 'none',
                })
                .to(cards[0], {
                    backgroundColor: '#ECFFB4',
                    ease: 'none',
                }, '>')
                .from(cards[1], {
                    y: windowHeight - heading_reviews_factsRect.height - topStyleValueReviews,
                    rotateX: 40,
                    rotate: 10,
                    ease: 'none',
                }, '>-=.63')
                .to(cards[1], {
                    backgroundColor: '#ECFFB4',
                    ease: 'none',
                }, '>')
                .from(cards[2], {
                    y: windowHeight - heading_reviews_factsRect.height - topStyleValueReviews,
                    rotateX: 40,
                    rotate: 10,
                    ease: 'none',
                }, '>-=.63')
        }
    }

    const rotateElement = gsap.utils.toArray('[data-rotate]')
    if(rotateElement) {
        rotateElement.forEach(item => {
            const rotateNumber = item.dataset.rotate
            gsap.timeline({
                scrollTrigger: {
                    trigger: item,
                    scrub: 1,
                    start: `top bottom`,
                    end: `150%`,
                }
            })
                .to(item, {
                    rotate:rotateNumber ? rotateNumber : 10,
                    ease: 'none',
                }, '<')
        })
    }

    const sectionsWrapColor = gsap.utils.toArray('.section_color_bg[data-color]')
    if(sectionsWrapColor) {
        sectionsWrapColor.forEach(section => {
            const color = section.dataset.color
            if (!color) return

            ScrollTrigger.create({
                trigger: section,
                start: 'top top+=110%',
                end: 'bottom bottom',
                onEnter: () => {
                    if(disableBackgroundColor) return
                    gsap.to(mainWrapper, {
                        backgroundColor: color,
                        duration: 0.6,
                        ease: 'power2.out'
                    })
                },
                onEnterBack: () => {
                    if(disableBackgroundColor) return
                    gsap.to(mainWrapper, {
                        backgroundColor: color,
                        duration: 0.6,
                        ease: 'power2.out'
                    })
                }
            })
        })

        // const themeMeta = document.querySelector('meta[name="theme-color"]');
        // if (themeMeta && window.ScrollTrigger) {
        //     const getBg = () => getComputedStyle(document.body).backgroundColor;
        //     const setTheme = (c) => themeMeta.setAttribute('content', c);

        //     let last = '';
        //     const sync = () => {
        //         const bg = getBg();
        //         if (bg !== last) setTheme((last = bg));
        //     };

        //     sync();
        //     ScrollTrigger.create({ start: 0, end: 'max', onUpdate: sync });
        // }
    }

    gsap.utils.toArray('[data-slide-down]').forEach(item => {
        const count = item.getAttribute('data-slide-down')
        const delay = item.getAttribute('data-delay')
        gsap.set(item, {y:count ? count : 10,autoAlpha:0})
        gsap.to(item, {
            y:0,
            delay: delay ? delay : 0,
            duration:1,
            autoAlpha:1,
            ease: "power3.out",
            scrollTrigger: {
                trigger: item,
                start: 'top 85%',
                scrub: false
            },
        })
    })

    gsap.utils.toArray('.group_title_decor').forEach(item => {
        const splittingText = item.querySelector('[data-anim-splitting-scroll]')
        if (!splittingText) return

        const decorIcon = item.querySelectorAll('[data-decor-title]')
        const hasDecorIcon = decorIcon && decorIcon.length > 0

        const linesSplit = new SplitText(splittingText, {
            type: 'lines, words, chars',
            // mask: 'lines',
            linesClass: 'text-line',
        })

        if (hasDecorIcon) {
            gsap.set(decorIcon, {
                autoAlpha: 0,
                filter: 'blur(10px)'
            })
        }

        gsap.set(linesSplit.chars, {
            x: 50,
            autoAlpha:0,
            // rotate: 5,
            filter: 'blur(5px)'
        })

        const tlSplitLines = gsap.timeline({
            scrollTrigger: {
                trigger: item,
                start: windowWidth >= 1280 ? 'top 70%' : 'top 90%',
                scrub: false
            }
        })

        tlSplitLines.to(linesSplit.chars, {
            autoAlpha:1,
            x: 0,
            rotate: 0,
            duration: 2,
            stagger: 0.02,
            filter: 'blur(0px)',
            ease: 'expo.out'
        }, 0)

        if (hasDecorIcon) {
            const attrDelay = decorIcon[0].getAttribute('data-decor-title')
            const decorIconDelay = attrDelay ? parseFloat(attrDelay) : 0.7

            tlSplitLines.to(decorIcon, {
                // delay: decorIconDelay,
                filter: 'blur(0px)',
                autoAlpha: 1,
                duration: 1.5,
                ease: 'expo.out',
                stagger: 0.08
            }, '<=+1')
        }
    })
}

function initAccordion() {
    const accordion_section = document.querySelector('.accordion_section');
    if (!accordion_section) return

    const groups = gsap.utils.toArray('.js_accordion__group');
    const menus = gsap.utils.toArray('.js_accordion__menu');
    const animations = [];

    groups.forEach(group => createAnimation(group));

    menus.forEach(menu => {
        menu.addEventListener('click', () => toggleAnimation(menu));
    })

    function toggleAnimation(menu) {
        const selectedReversedState = menu.animation.reversed();
        animations.forEach(animation => animation.reverse());

        menu.animation.reversed(!selectedReversedState);
    }

    function createAnimation(element) {
        const menu = element.querySelector('.js_accordion__menu');
        const box = element.querySelector('.js_accordion__content');
        const icon_line = element.querySelector('.js_accordion__icon_line');
        const icon = element.querySelector('.js_accordion__icon');
        const content = element.querySelectorAll('.js_accordion__content p');

        gsap.set(box, {height: 'auto'})

        const tlAccordion = gsap.timeline({
            reversed: true,
            paused: !0,
            onComplete: () => {
                ScrollTrigger.refresh()
            }
        });

        tlAccordion
            .from(box, {
                height: 0,
                duration: .6,
                ease: 'power3.inOut'
            })
            .to(icon, {
                duration: .6,
                rotateX: 180,
                ease: 'linear'
            }, '<')

        menu.animation = tlAccordion;
        animations.push(tlAccordion);
    }
}

function resetScrollToTop() {
    if ('scrollRestoration' in history) {
        history.scrollRestoration = 'manual'
    }

    if (!pendingApplyFormHashScroll && location.hash !== APPLY_FORM_HASH) {
        return
    }

    pendingApplyFormHashScroll = true

    const resetScrollTop = () => {
        window.scrollTo(0, 0)
        document.body.scrollTop = 0
        document.documentElement.scrollTop = 0

        if (mainWrapper) {
            mainWrapper.scrollTop = 0
        }

        if (scroll && typeof scroll.scrollTo === 'function') {
            scroll.scrollTo(0, { immediate: true })
        }
    }

    resetScrollTop()

    window.addEventListener('pageshow', event => {
        if (event.persisted && (pendingApplyFormHashScroll || location.hash === APPLY_FORM_HASH)) {
            resetScrollTop()
        }
    })
}

function initLangSwitcher() {
    const wrapper = document.querySelector('.wrapper_lang')
    if (!wrapper) return

    const btn = wrapper.querySelector('.btn_toggle_lang')

    document.addEventListener('click', e => {
        if (btn.contains(e.target)) {
            wrapper.classList.toggle('is_opened')
            return
        }

        if (!wrapper.contains(e.target)) {
            wrapper.classList.remove('is_opened')
        }
    })
}

function formContactPopup() {
    const openPopupButtons = document.querySelectorAll('[data-open-popup]')
    const popup = document.getElementById('contact_popup')

    if (!popup || !openPopupButtons.length) return

    const inner = popup.querySelector('.inner_popup')
    const closeBtn = popup.querySelectorAll('[data-close-popup]')
    const wrapHeadForm = popup.querySelector('.wrap_head_form')
    const form = popup.querySelector('#form_contact')
    const popupEmailInput = form.querySelector('input[name="email"]')
    const stepsWrapper = popup.querySelector('.steps-wrapper')
    const steps = Array.from(popup.querySelectorAll('.item_form_step'))
    const progressBars = Array.from(popup.querySelectorAll('.inside_acts'))
    const nextBtn = form.querySelector('button[type="submit"]')

    const formWrapper = popup.querySelector('.form_wrapper')
    const thanksWrapper = popup.querySelector('.thanks_wrapper')
    const stepsFooter = popup.querySelector('.steps_footer')

    let currentStep = 0

    gsap.set([popup, inner], { autoAlpha: 0 })
    gsap.set(popup, { display: 'none' })

    const tl = gsap.timeline({
        paused: true
    })

    tl
        .to(popup, {
            duration: .5,
            autoAlpha: 1,
            display: 'block'
        })
        .fromTo(
            inner,
            { scale: 0.9, autoAlpha: 0, y: 20 },
            { scale: 1, autoAlpha: 1, y: 0, duration: .5 },
            '<'
        )

    tl.eventCallback('onReverseComplete', () => {
        gsap.set(popup, { display: 'none' })
    })

    function resetPopupState() {
        if (!form) return

        form.reset()

        popup.querySelectorAll('.error').forEach(el => el.classList.remove('error'))

        const profile = document.querySelector('input[name="profile"]')
        if (profile) {
            profile.readOnly = false
        }

        if (formWrapper) {
            gsap.set(formWrapper, { autoAlpha: 1, y: 0, height: 'auto' })
        }
        if (thanksWrapper) {
            gsap.set(thanksWrapper, { autoAlpha: 0, height:0})
        }

        if (stepsFooter) {
            gsap.set(stepsFooter, { height: 'auto' })
        }

        currentStep = 0

        steps.forEach((step, i) => {
            if (i === 0) {
                gsap.set(step, { autoAlpha: 1, y: 0 })
            } else {
                gsap.set(step, { autoAlpha: 0, y: 0 })
            }
        })

        if (stepsWrapper && steps[0]) {
            const h = steps[0].offsetHeight
            if (h) stepsWrapper.style.height = h + 'px'
        }

        progressBars.forEach((bar, i) => {
            gsap.set(bar, { width: i === 0 ? '100%' : '0%' })
        })

        const head1 = popup.querySelector('.heading_txt_1')
        const head2 = popup.querySelector('.heading_txt_2')
        if (head1 && head2) {
            head1.classList.remove('invisible', 'opacity-0', 'translate-y-2')
            head2.classList.add('invisible')
            head2.classList.add('opacity-0')
            head2.classList.add('translate-y-2')
        }

        inner.classList.remove('is_next_step')

        const labels = nextBtn.querySelectorAll('.wrapper_btn_tx span')
        labels.forEach(span => {
            span.textContent = 'next'
        })
    }

    function openPopupFn(e) {
        if (e) e.preventDefault()

        const trigger = e?.currentTarget || e?.target?.closest('[data-open-popup]')

        resetPopupState()

        if (trigger && trigger.dataset.emailSource && popupEmailInput) {
            const sourceInput = document.querySelector(trigger.dataset.emailSource)
            const emailValue = sourceInput?.value?.trim()

            if (emailValue) {
                popupEmailInput.value = emailValue
            }
        }

        tl.play(0)

        requestAnimationFrame(() => {
            if (stepsWrapper && steps[currentStep]) {
                const h = steps[currentStep].offsetHeight
                if (h) stepsWrapper.style.height = h + 'px'
            }
        })

        if (trigger && trigger.dataset.skipFirstStep === 'true') {
            goToStep(1)
        }

        scroll.stop()
    }

    function closePopupFn() {
        scroll.start()
        tl.reverse()
    }

    function updateProgress(stepIndex) {
        progressBars.forEach((bar, i) => {
            const targetWidth = i <= stepIndex ? '100%' : '0%'
            gsap.to(bar, {
                delay:.1,
                width: targetWidth
            })
        })

        const labels = nextBtn.querySelectorAll('.wrapper_btn_tx span')
        const isLast = stepIndex === steps.length - 1
        labels.forEach(span => {
            span.textContent = isLast ? 'submit' : 'next'
        })
    }

    function updateInnerClass() {
        if (currentStep > 0) {
            inner.classList.add('is_next_step')
        } else {
            inner.classList.remove('is_next_step')
        }
    }

    function validateFields(container) {
        const fields = container.querySelectorAll('input, textarea, select')
        let isValid = true
        let firstInvalid = null
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/

        fields.forEach(field => {
            let value = String(field.value || '').trim()
            if (field.tagName === 'SELECT' && field.selectedIndex === 0) {
                value = ''
            }

            if (field.type === 'email' && value) {
                if (!emailRegex.test(value)) {
                    value = ''
                }
            }

            const wrapper = field.closest('.form-field') || field

            if (!value) {
                isValid = false
                if (!firstInvalid) firstInvalid = field
                field.classList.add('error')
                wrapper.classList.add('error')
            } else {
                field.classList.remove('error')
                wrapper.classList.remove('error')
            }
        })

        if (!isValid && firstInvalid) firstInvalid.focus()
        return isValid
    }

    function validateCurrentStep() {
        return validateFields(steps[currentStep])
    }

    function validateAllSteps() {
        let isValid = true
        steps.forEach(step => {
            if (!validateFields(step)) isValid = false
        })
        return isValid
    }

    function goToStep(nextIndex) {
        if (nextIndex === currentStep) return
        if (nextIndex < 0 || nextIndex >= steps.length) return

        const currentEl = steps[currentStep]
        const nextEl = steps[nextIndex]

        let oldHeight = 0
        let newHeight = 0

        if (stepsWrapper) {
            oldHeight = stepsWrapper.offsetHeight || 0
            newHeight = nextEl.offsetHeight || 0
        }

        steps.forEach((step, i) => {
            if (i !== nextIndex) {
                gsap.to(step, { autoAlpha: 0, y: 0, duration: .5 })
            }
        })

        if (currentEl !== nextEl) {
            gsap.to(currentEl, {
                autoAlpha: 0,
                y: -10,
                duration: .5
            })
        }

        gsap.fromTo(
            nextEl,
            { autoAlpha: 0, y: 10, duration: .5 },
            { autoAlpha: 1, y: 0, duration: .5 }
        )

        if (stepsWrapper && newHeight) {
            if (!oldHeight) {
                stepsWrapper.style.height = newHeight + 'px'
            } else {
                gsap.fromTo(
                    stepsWrapper,
                    { height: oldHeight },
                    {
                        height: newHeight,
                        duration: .5,
                        onComplete() {
                            stepsWrapper.style.height = newHeight + 'px'
                        }
                    }
                )
            }
        }

        currentStep = nextIndex
        updateProgress(currentStep)
        updateInnerClass()
    }

    steps.forEach((step, i) => {
        if (i === 0) {
            gsap.set(step, { autoAlpha: 1, y: 0, duration: .5 })
        } else {
            gsap.set(step, { autoAlpha: 0, y: 0, duration: .5 })
        }
    })

    updateProgress(currentStep)
    updateInnerClass()

    openPopupButtons.forEach(btn => {
        btn.addEventListener('click', openPopupFn)
    })

    if (closeBtn) {
        closeBtn.forEach(item => {
            item.addEventListener('click', e => {
                e.preventDefault()
                closePopupFn()
            })
        })
    }

    popup.addEventListener('click', e => {
        if (!inner.contains(e.target)) {
            closePopupFn()
        }
    })

    document.addEventListener('keydown', e => {
        if (e.key === 'Escape' && tl.progress() > 0) {
            closePopupFn()
        }
    })

    if (wrapHeadForm) {
        wrapHeadForm.addEventListener('click', e => {
            e.preventDefault()
            if (currentStep > 0) {
                goToStep(currentStep - 1)
            }
        })
    }

    function afterSubmit() {
        if (!formWrapper || !thanksWrapper) return

        const emailInput = document.getElementById('email_start_form')
        const tlEnd = gsap.timeline()

        gsap.set(thanksWrapper, { display: 'block', height: 'auto' })
        const targetHeight = thanksWrapper.offsetHeight || thanksWrapper.scrollHeight || 0
        gsap.set(thanksWrapper, { height: 0,display: 'none', autoAlpha:1 })
        gsap.set('.thanks_wrapper > div', { autoAlpha:0 })

        tlEnd
            .to(formWrapper, {
                autoAlpha: 0,
                duration: .5
            })
            .to(formWrapper, {
                height: 0,
                duration: .5
            }, '<+=.2')

            .to(stepsFooter, {height: 0, duration: .5}, '<')

            .fromTo(thanksWrapper,{display: 'block',height: 0,duration: .5},{height: targetHeight,onComplete() {thanksWrapper.style.height = 'auto'}},'<')
            .to('.thanks_wrapper > div', {autoAlpha: 1,stagger:.04, duration: .5, onComplete() {form.reset();emailInput.value = ''}}, '>-=.2')
    }

    form.addEventListener('submit', e => {
        e.preventDefault()
        const formData = new FormData(e.currentTarget)

        const isLast = currentStep === steps.length - 1

        if (!isLast) {
            if (!validateCurrentStep()) return
            goToStep(currentStep + 1)
            return
        }

        if (!validateAllSteps()) {
            return
        }else {
            nextBtn.classList.add('loading')
            fetch('/vendor/form-contact.php', {
                method: 'POST',
                body: formData
            })
                .then(response => {
                    if (!response.ok) {
                        throw new Error('Network error: ' + response.status)
                    }
                    return response.json()
                })
                .then(data => {
                    if (!data.success) {
                        console.error('Server error:', data.error)
                        return
                    }
                    afterSubmit()
                })
                .catch(err => {
                    console.error('fetch error:', err)
                })
                .finally(() => {
                    nextBtn.classList.remove('loading')
                })
        }
    })

    initEmailButton()
    tiktokFieldLogic()
}

function tiktokFieldLogic() {
    const followers = document.getElementById('followers')
    if (!followers) {
        return
    }

    const profile = document.querySelector('input[name="profile"]')
    if (!profile) {
        return
    }

    const NO_PROFILE_TEXT = 'No TikTok profile'
    const NO_PROFILE_VALUE = '-'

    const apply = () => {
        const selectedText = (followers.options[followers.selectedIndex]?.text || '').trim()
        const isNoProfile = selectedText === NO_PROFILE_TEXT

        if (isNoProfile) {
            profile.value = NO_PROFILE_VALUE
            profile.readOnly = true
            profile.setAttribute('aria-disabled', 'true')
            profile.classList.remove('error')
            followers.classList.remove('error')
        } else {
            if (profile.value === NO_PROFILE_VALUE) profile.value = ''
            profile.readOnly = false
            profile.removeAttribute('aria-disabled')
        }
    }

    followers.addEventListener('change', apply)
    apply()
}

function initEmailButton() {
    const emailInput = document.getElementById('email_start_form')
    const startBtn   = document.getElementById('btn_get_start')
    if (!emailInput || !startBtn) return

    const handler = () => {
        const value = emailInput.value.trim()

        const isValidEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)

        startBtn.disabled = !isValidEmail
        startBtn.classList.toggle('opacity-50', !isValidEmail)
        startBtn.classList.toggle('pointer-events-none', !isValidEmail)
    }

    emailInput.addEventListener('input', handler)
    handler()
}

function menuMobile() {
    const menu = document.getElementById('menu_site')
    const openBtns = document.querySelectorAll('[data-open-menu]')
    const closeBtns = menu ? menu.querySelectorAll('[data-close-popup]') : []
    const inside = menu ? menu.querySelectorAll('.item_row_menu') : []
    const applyFormLinks = menu
        ? menu.querySelectorAll('a[data-apply-form-hash-link], a[data-certificate-hash-link], a[href="#apply-form"], a[href="/#apply-form"], a[href$="#apply-form"]')
        : []

    if (!menu || !openBtns.length) return

    gsap.set(menu, { yPercent: -100})
    gsap.set(inside, { autoAlpha:0,y:-10,scale:.95 })

    const tl = gsap.timeline({ paused: true })
        .set(menu, { display: 'block' })
        .to(menu, { yPercent: 0,duration:.7 })
        .to(inside, { autoAlpha:1, stagger:-.04, scale:1,y:0,duration:.7 }, '<+=.2')

    tl.eventCallback('onReverseComplete', () => {
        gsap.set(menu, { display: 'none' })
    })

    const open = () => tl.timeScale(1).play()
    const close = () => tl.timeScale(2).reverse()

    openBtns.forEach(btn => btn.addEventListener('click', open))
    closeBtns.forEach(btn => btn.addEventListener('click', close))
    applyFormLinks.forEach(link => link.addEventListener('click', close))
}

function waveSections() {
    const waveItem = document.querySelectorAll('.wave_wrapper')
    if (waveItem) {
        waveItem.forEach(item => {
            const path1 = item.querySelector('.wave1')
            if (path1) {
                const pointSpacing = 20
                const width = 1920
                const baseY = 75

                function updateWavePaths(offset) {
                    const points1 = []
                    const points2 = []

                    for (let x = 0; x <= width; x += pointSpacing) {
                        const y1 = baseY + 10 * Math.sin(x * 0.002 + offset)
                        const y2 = baseY + 15 * Math.sin(x * 0.003 + offset + 0.2)

                        points1.push(`${x},${y1}`)
                        points2.push(`${x},${y2}`)
                    }

                    const pathData1 = `M0,150 L0,75 ${points1.join(' ')} L${width},150 Z`
                    const pathData2 = `M0,150 L0,75 ${points2.join(' ')} L${width},150 Z`

                    path1.setAttribute('d', pathData1)
                }

                gsap.ticker.add(time => {
                    const offset = time * 1.5
                    updateWavePaths(offset)
                })
            }
        })
    }
}

function initLazyVideos() {
    initObserverHub()
    const supportsHover = matchMedia('(hover: hover) and (pointer: fine)').matches

    const videos = document.querySelectorAll('[data-video-lazy]')
    if(videos.length) {
        videos.forEach(video => {
            const src = (video.dataset.videoSrc || '').trim()
            if (!src) return

            if (!video.dataset.videoStatus) {
                video.dataset.videoStatus = 'not-loaded'
            }

            if (video.getAttribute('src') === null) {
                video.setAttribute('src', '')
            }

            const lazyAttr = (video.getAttribute('data-video-lazy') || '').toLowerCase()
            const isHoverRequested = lazyAttr === 'hover'
            const useHoverMode = isHoverRequested && supportsHover

            let hydrating = false
            let hydrated = false
            let hoverLeaveTimeout = null

            function startHydration() {
                if (hydrating || hydrated) return
                if (!src) return

                hydrating = true

                video.muted = true
                video.playsInline = true
                video.preload = 'metadata'

                if (!video.getAttribute('src')) {
                    video.setAttribute('src', src)
                }

                try {
                    video.load()
                } catch (err) {}

                function onLoaded() {
                    video.removeEventListener('loadeddata', onLoaded)
                    video.removeEventListener('canplay', onLoaded)

                    video.dataset.videoStatus = 'loaded'
                    hydrating = false
                    hydrated = true
                }

                video.addEventListener('loadeddata', onLoaded)
                video.addEventListener('canplay', onLoaded)
            }

            function setupHoverMode() {
                const hoverTarget = video.closest('[data-video-lazy-hover]') || video

                function onEnter() {
                    if (hoverLeaveTimeout) {
                        clearTimeout(hoverLeaveTimeout)
                        hoverLeaveTimeout = null
                    }

                    if (!hydrated) {
                        startHydration()
                    }

                    if (!video.getAttribute('src')) {
                        video.setAttribute('src', src)
                    }

                    video.dataset.videoStatus = 'loaded'

                    try {
                        video.currentTime = 0
                    } catch (err) {}

                    try {
                        video.play()
                    } catch (err) {}
                }

                function onLeave() {
                    video.dataset.videoStatus = 'not-loaded'

                    hoverLeaveTimeout = setTimeout(() => {
                        try {
                            video.pause()
                        } catch (err) {}

                        try {
                            video.currentTime = 0
                        } catch (err) {}

                        hoverLeaveTimeout = null
                    }, 200)
                }

                hoverTarget.addEventListener('mouseenter', onEnter)
                hoverTarget.addEventListener('mouseleave', onLeave)

                if (window.addDisposable) {
                    addDisposable(() => {
                        hoverTarget.removeEventListener('mouseenter', onEnter)
                        hoverTarget.removeEventListener('mouseleave', onLeave)
                        if (hoverLeaveTimeout) {
                            clearTimeout(hoverLeaveTimeout)
                            hoverLeaveTimeout = null
                        }
                    })
                }

                const disposeObserver = observeWith(video, { threshold: 0 }, entry => {
                    if (!entry.isIntersecting) {
                        try {
                            video.pause()
                        } catch (err) {}
                    }
                })

                if (window.addDisposable && disposeObserver) {
                    addDisposable(disposeObserver)
                }
            }

            function setupScrollMode() {
                const disposeObserver = observeWith(video, { threshold: 0.15 }, entry => {
                    if (entry.isIntersecting) {
                        if (!hydrated) {
                            startHydration()
                        }
                        video.dataset.videoStatus = 'loaded'
                        try {
                            video.play()
                        } catch (err) {}
                    } else {
                        try {
                            video.pause()
                        } catch (err) {}
                    }
                })

                if (window.addDisposable && disposeObserver) {
                    addDisposable(disposeObserver)
                }

                if (video.dataset.videoStatus === 'loaded' && !hydrated) {
                    startHydration()
                }
            }

            if (useHoverMode) {
                setupHoverMode()
            } else {
                setupScrollMode()
            }
        })
    }
}

function initObserverHub() {
    if (window.__observerHubInit) return;
    window.__observerHubInit = !0;
    const t = new Map();
    ((window.getObserver = function (e = {}) {
        const a = (function (t = {}) {
            const e = Array.isArray(t.threshold)
                    ? t.threshold.join(",")
                    : (t.threshold ?? 0),
                a = t.rootMargin ?? "0px 0px 0px 0px";
            return JSON.stringify({ t: e, r: a });
        })(e);
        if (t.has(a)) return t.get(a);
        const r = new IntersectionObserver((t) => {
            for (let e = 0; e < t.length; e++) {
                const a = t[e],
                    r = a.target.__ioCallbacks;
                if (r) for (let t = 0; t < r.length; t++) r[t](a);
            }
        }, e);
        return (t.set(a, r), r);
    }),
        (window.observeWith = function (t, e = {}, a) {
            if (!t || "function" != typeof a) return () => {};
            const r = getObserver(e);
            ((t.__ioCallbacks = t.__ioCallbacks || []),
                t.__ioCallbacks.push(a),
                r.observe(t));
            const n = () => {
                t.__ioCallbacks &&
                (t.__ioCallbacks = t.__ioCallbacks.filter((t) => t !== a));
                try {
                    r.unobserve(t);
                } catch (t) {}
            };
            return window.addDisposable ? window.addDisposable(n) : n;
        }));
}

function getCurrentScrollPosition() {
    if (scroll && typeof scroll.actualScroll === 'number') {
        return scroll.actualScroll
    }

    if (window.innerWidth < 1280 && mainWrapper) {
        return mainWrapper.scrollTop || 0
    }

    return window.scrollY || window.pageYOffset || document.documentElement.scrollTop || 0
}

function getApplyFormViewportOffset() {
    if (window.innerWidth >= 1280) {
        return Math.round(Math.min(56, Math.max(36, window.innerHeight * 0.05)))
    }

    return 24
}

function getApplyFormTarget() {
    return document.querySelector(APPLY_FORM_TITLE_SELECTOR)
}

function waitForApplyFormAssets() {
    const section = document.querySelector(APPLY_FORM_SECTION_SELECTOR)
    const media = section?.querySelector(APPLY_FORM_MEDIA_SELECTOR)
    const waits = []

    if (document.fonts?.ready) {
        waits.push(document.fonts.ready.catch(() => {}))
    }

    if (media?.decode) {
        waits.push(media.decode().catch(() => {}))
    } else if (media && !media.complete) {
        waits.push(new Promise(resolve => {
            media.addEventListener('load', resolve, { once: true })
            media.addEventListener('error', resolve, { once: true })
        }))
    }

    return Promise.allSettled(waits)
}

function waitForWindowLoad() {
    if (document.readyState === 'complete') {
        return Promise.resolve()
    }

    return new Promise(resolve => {
        window.addEventListener('load', resolve, { once: true })
    })
}

function waitForFrames(count = 1) {
    return new Promise(resolve => {
        const step = () => {
            count -= 1
            if (count <= 0) {
                resolve()
                return
            }

            requestAnimationFrame(step)
        }

        requestAnimationFrame(step)
    })
}

function delay(ms) {
    return new Promise(resolve => setTimeout(resolve, ms))
}

function isApplyFormAligned(tolerance = 8) {
    const target = getApplyFormTarget()
    if (!target) return false

    const viewportOffset = getApplyFormViewportOffset()
    const delta = Math.abs(target.getBoundingClientRect().top - viewportOffset)
    return delta <= tolerance
}

async function stabilizeApplyFormPosition(requestId, { maxIterations = 14, delayMs = 120 } = {}) {
    let stablePasses = 0

    for (let iteration = 0; iteration < maxIterations; iteration += 1) {
        if (requestId !== applyFormNavigationRequestId) return false

        ScrollTrigger.refresh()
        await waitForFrames(2)

        if (requestId !== applyFormNavigationRequestId) return false

        scrollToApplyForm({ immediate: true })
        await waitForFrames(2)

        if (requestId !== applyFormNavigationRequestId) return false

        if (isApplyFormAligned()) {
            stablePasses += 1
            if (stablePasses >= 3) {
                return true
            }
        } else {
            stablePasses = 0
        }

        await delay(delayMs)
    }

    return isApplyFormAligned(16)
}

function scrollToApplyForm({ immediate = false } = {}) {
    const target = getApplyFormTarget()
    if (!target) return false

    const viewportOffset = getApplyFormViewportOffset()

    if (window.innerWidth < 1280 && mainWrapper) {
        const mainRect = mainWrapper.getBoundingClientRect()
        const targetRect = target.getBoundingClientRect()
        const targetY = Math.max(0, mainWrapper.scrollTop + targetRect.top - mainRect.top - viewportOffset)

        mainWrapper.scrollTo({
            top: targetY,
            behavior: immediate ? 'auto' : 'smooth',
        })

        if (scroll && typeof scroll.scrollTo === 'function') {
            scroll.scrollTo(targetY, {
                duration: immediate ? 0 : 1,
                immediate,
                lock: false,
                force: true,
            })
        }

        return true
    }

    if (scroll && typeof scroll.scrollTo === 'function') {
        scroll.scrollTo(target, {
            duration: immediate ? 0 : 1,
            immediate,
            offset: -viewportOffset,
            lock: false,
            force: true,
        })
    } else {
        const targetY = Math.max(0, getCurrentScrollPosition() + target.getBoundingClientRect().top - viewportOffset)
        window.scrollTo({
            top: targetY,
            behavior: immediate ? 'auto' : 'smooth',
        })
    }

    return true
}

async function handleApplyFormHashNavigation({ immediate = false, initial = false } = {}) {
    if (!initial && location.hash !== APPLY_FORM_HASH && !pendingApplyFormHashScroll) {
        return
    }

    pendingApplyFormHashScroll = true
    const requestId = ++applyFormNavigationRequestId

    try {
        if (initial) {
            await waitForWindowLoad()
        }

        await waitForApplyFormAssets()
        await waitForFrames(2)

        if (requestId !== applyFormNavigationRequestId) return

        ScrollTrigger.refresh()
        await waitForFrames(1)

        if (requestId !== applyFormNavigationRequestId) return

        scrollToApplyForm({ immediate })

        if (initial) {
            await stabilizeApplyFormPosition(requestId)

            if (requestId !== applyFormNavigationRequestId) return

            history.replaceState(null, '', APPLY_FORM_HASH)
            window.__applyFormHashRequested = false
            releaseApplyFormPendingState()
            hidePreloader()
        }
    } catch (error) {
        if (initial) {
            releaseApplyFormPendingState()
            hidePreloader()
        }
    } finally {
        if (requestId === applyFormNavigationRequestId) {
            pendingApplyFormHashScroll = false
        }
    }
}

function initApplyFormHashNavigation() {
    const target = getApplyFormTarget()
    if (!target) {
        if (pendingApplyFormHashScroll) {
            hidePreloader()
        }
        return
    }

    document.addEventListener('click', event => {
        const link = event.target.closest('a[href$="#apply-form"]')
        if (!link) return

        const href = link.getAttribute('href') || ''
        const isSamePageHash = href === APPLY_FORM_HASH || href.endsWith(APPLY_FORM_HASH)
        if (!isSamePageHash) return

        event.preventDefault()
        pendingApplyFormHashScroll = true

        if (window.location.hash !== APPLY_FORM_HASH) {
            history.pushState(null, '', APPLY_FORM_HASH)
        }

        handleApplyFormHashNavigation({ immediate: false })
    })

    window.addEventListener('hashchange', () => {
        if (window.location.hash === APPLY_FORM_HASH) {
            pendingApplyFormHashScroll = true
            handleApplyFormHashNavigation({ immediate: false })
        }
    })

    let resizeTimer = null
    window.addEventListener('resize', () => {
        if (window.location.hash !== APPLY_FORM_HASH) return

        clearTimeout(resizeTimer)
        resizeTimer = setTimeout(() => {
            scrollToApplyForm({ immediate: true })
        }, 120)
    })

    if (pendingApplyFormHashScroll) {
        handleApplyFormHashNavigation({ immediate: true, initial: true })
    } else if (window.location.hash === APPLY_FORM_HASH) {
        releaseApplyFormPendingState()
        handleApplyFormHashNavigation({ immediate: true })
    } else {
        releaseApplyFormPendingState()
    }
}
